interface VanityTag {
    rankIdentifiers: string[]
    textColor: string
    backgroundColor: string
    displayName: string
    description: string
}

export const VanityTagInformation: VanityTag[] = [
    {
        rankIdentifiers: ["server_owner"],
        textColor: "white",
        backgroundColor: "a64747",
        displayName: "Owner",
        description: "A PERPHeads server owner, while they do have full power over all aspects of the server they generally do not handle issues with the PLPD directly"
    },
    {
        rankIdentifiers: ["server_developer"],
        textColor: "white",
        backgroundColor: "ff9128",
        displayName: "Developer",
        description: "A PERPHeads developer that has some involvement with the development of the PLPD either through PLPD Online code work, server PD code work, or both"
    },
    {
        rankIdentifiers: ["server_senior_staff", "server_cm"],
        textColor: "white",
        backgroundColor: "9d69e5",
        displayName: "Staff",
        description: "A member of the PERPHeads staff team that ranks Administrator or higher, has some basic moderation powers on PLPD Online"
    }
]